export default {"src":"/_next/static/media/light-logo.39680ec4.svg","height":60,"width":310,"blurWidth":0,"blurHeight":0};